import { Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../../../../common/components/icon/icon.component';
import { Gender } from '../../../../../../../core/data/enums/gender.enum';
import { InsuranceTypeDto } from '../../../../../../../core/data/dtos/insurance-type.dto';
import { DatepickerInputComponent } from '../../../../../../../common/components/datepicker-input/datepicker-input.component';

@Component({
  selector: 'app-children-dependents',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppIconComponent,
    DatepickerInputComponent,
  ],
  templateUrl: './children-dependents.component.html',
})
export class ChildrenDependentsComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) option!: InsuranceTypeDto;
  @Input({ required: true }) childrenArray!: FormArray<FormGroup>;

  addChildEvent = output<void>();
  removeChildEvent = output<number>();

  readonly Gender = Gender;

  addChild(): void {
    this.addChildEvent.emit();
  }

  removeChild(index: number): void {
    this.removeChildEvent.emit(index);
  }
}
